import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ISubjectList, QuestionManagementService } from 'src/app/Services/question-management.service';
import { ITreeNode } from '../../content-management/content-studyunit-topics/content-studyunit-topics.component';
import { IQuestionsWithAnswersModifiedResponse } from 'src/app/interfaces/questionManagement';
import { ConfirmRelocateModalComponent } from '../relocate-question-modal/relocate-question-modal.component';
import { ConstantVars } from 'src/app/utils/constants/constants';

@Component({
  selector: 'app-question-relocate-tree-modal',
  templateUrl: './question-relocate-tree-modal.component.html',
  styleUrls: ['./question-relocate-tree-modal.component.css']
})
export class QuestionRelocateTreeModalComponent implements OnInit {

  @Input() selectedQuestions: IQuestionsWithAnswersModifiedResponse[];
  @Input() selectedSubject: any;
  @Input() fromSubject: number;

  LEVEL_ORDER: string[] = ['MT', 'C', 'SCL1', 'SCL2', 'SCL3', 'SCL4', 'SCL5', 'SCL6'];
  MajorTopics: ITreeNode[] = [];
  selectedNode: ITreeNode | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    public questionService: QuestionManagementService,
    private readonly toaster: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.expandTree();
    this.setExpandFlags(this.MajorTopics);
  }

  expandTree() {
    const payload = {
      "SubjectID": this.selectedSubject,
      "Keyword": ""
    };
    this.questionService.getSubjectList(payload).subscribe({
      next: (res) => {
        const nestedSubjects = this.buildLevelHierarchy(res);
        this.MajorTopics = nestedSubjects.map(this.mapSubjectToTreeNode.bind(this));
        this.setExpandFlags(this.MajorTopics);
        console.log(this.MajorTopics);
        
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  buildLevelHierarchy(subjects: ISubjectList[]): ISubjectList[] {
    const LEVEL_ORDER = this.LEVEL_ORDER;
    const byParent: { [key: number]: ISubjectList[] } = {};
    subjects.forEach(sub => {
      if (!byParent[sub.Parent_Subject_Id]) byParent[sub.Parent_Subject_Id] = [];
      byParent[sub.Parent_Subject_Id].push(sub);
    });
    const subjectIds = new Set(subjects.map(s => s.Subject_Id));
    const rootParentIds = Array.from(new Set(subjects.filter(s => !subjectIds.has(s.Parent_Subject_Id)).map(s => s.Parent_Subject_Id)));
    const sortSubjects = (arr: ISubjectList[]) => {
      arr.sort((a, b) => {
        const l1 = LEVEL_ORDER.indexOf(a.Subject_Level_Type_Code);
        const l2 = LEVEL_ORDER.indexOf(b.Subject_Level_Type_Code);
        if (l1 !== l2) return l1 - l2;
        return a.Display_Order - b.Display_Order;
      });
    };
    function nest(parentId: number, levelIdx: number): ISubjectList[] {
      const children = (byParent[parentId] || []).filter(
        sub => sub.Subject_Level_Type_Code === LEVEL_ORDER[levelIdx]
      );
      sortSubjects(children);
      children.forEach(child => {
        if (levelIdx + 1 < LEVEL_ORDER.length) {
          child.children = nest(child.Subject_Id, levelIdx + 1);
        }
      });
      return children;
    }
    let roots: ISubjectList[] = [];
    for (const rootParentId of rootParentIds) {
      roots = roots.concat(nest(rootParentId, 0));
    }
    return roots;
  }

  mapSubjectToTreeNode(subject: ISubjectList): ITreeNode {
    return {
      ID: subject.Subject_Id,
      Parent_Id: subject.Parent_Subject_Id,
      Display_Order: subject.Display_Order,
      Name: subject.Subject_Name,
      Subject_Level_Type_Code: subject.Subject_Level_Type_Code,
      Status_Code: subject.Subject_Level_Type_Code,
      ChildNodeExistInd: subject.Child_Topic_Exists_Ind,
      Study_Unit_Ind: '',
      Subject_Short_Code: '',
      Data: subject.children ? subject.children.map(this.mapSubjectToTreeNode.bind(this)) : null,
      LoggedInUserID: null,
      sessionLanguageTypeCode: null,
      Exam_Instance_Concept_Exists_Ind: '',
      Total_Count: 0,
      WIP_Count: 0,
      Submitted_Count: 0,
      Under_Review_Count: 0,
      Rework_Count: 0,
      Approved_Count: 0,
      defer_Count: 0,
      Rejected_Count: 0,
      checked: false,
      previous: false,
      TestingProbabilityTypeCode: null
    };
  }

  isLeaf(node: any): boolean {
    return !node.Data || node.Data.length === 0;
  }
  
  getChecked(event: Event): boolean {
    return !!(event.target && (event.target as HTMLInputElement).checked);
  }
  onCheckboxChange(node: any, checked: boolean): void {
    // Single-select logic: clear others, select only this node
    this.clearAllChecks(this.MajorTopics);
    node.checked = checked;
    this.selectedNode = checked ? node : null;
  }
  clearAllChecks(nodes: any[]): void {
    for (const node of nodes) {
      node.checked = false;
      if (node.Data && node.Data.length) this.clearAllChecks(node.Data);
    }
  }
  

  onCross() {
    this.activeModal.close(false);
  }

  setExpandFlags(nodes: any[]): void {
    nodes.forEach(node => {
      node.expanded = true; // Or true if you want everything open by default
      if (node.Data && node.Data.length) this.setExpandFlags(node.Data);
    });
  }
  toggleExpand(node: any): void {
    node.expanded = !node.expanded;
  }
  
  onSave() {
    if (!this.selectedNode) {
      this.toaster.error('Please select a topic to relocate the questions', "", { timeOut: ConstantVars.ToastErrorTimeout });
      return;
    }
    const modalRef = this.modalService.open(ConfirmRelocateModalComponent, {
      size: 'lg',
      centered: true,
      scrollable: true,
      windowClass: 'custom-confirm-relocate-modal-width-list',
    });

    modalRef.componentInstance.selectedQuestions = this.selectedQuestions;
    modalRef.componentInstance.selectedTopic = [{ ID: this.selectedNode.ID, Display_Order: this.selectedNode.Display_Order }];
    modalRef.componentInstance.fromSubject = this.fromSubject;
    modalRef.result.then((result) => {
      if (result === 'confirm') {
        this.activeModal.close('Saved');
      }
      if (result === 'cancel') {
        this.activeModal.close('cancel');
      }
    }, (reason) => {
      // cancelled
    });
  }
}
